<section fxLayout="column" fxLayoutGap="10px">
  <div class="branches" fxLayout="row" fxLayout.xs="column" fxLayoutGap="5px">
    <div>Choose Branch:</div>
    <mat-radio-group required [formControl]="branchControl"
                     fxLayout="row" fxLayoutGap="12px"
                     fxLayout.xs="column">
      <mat-radio-button *ngFor="let branch of branches|async"
                        color="primary" [value]="branch.pk">
        {{branch.name}}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <mat-error align="start" *ngIf="contactUs.form.dirty && contactUs.form.get('branch').hasError('required')">
    Required.
  </mat-error>
  <div fxLayout="row" fxLayoutAlign="stretch" fxLayout.xs="column">

    <iframe [src]='mapUrl|async'
            frameborder="0" style="border:0" allowfullscreen>
    </iframe>

    <div id="branch-details" fxFlex="30%" *ngIf="branch|async as branch">
      <h3>Balikbayad</h3>

      <ng-container *ngIf="[].includes(branch.alias)">
        <h4 style="color: red;">
          * Our branches are currently closed due to community quarantaine
        </h4>
      </ng-container>
      <ng-container *ngIf="['makati', 'manila', 'kalaw', 'cebu'].includes(branch.alias)">
        <h4 style="color: red;">
          * This branch is open and ready to serve you safely. Strict hygiene and social distancing is observed.
        </h4>
      </ng-container>

      <p>{{branch.address}}<br>({{branch.landmark}})</p>

      <span>PHONE NUMBER</span>
      <span *ngFor="let phone_contact of branch.phone_contacts">
        <br/>{{phone_contact}}
      </span>
      <br/><br/>
      <span>EMAIL ADDRESS</span>
      <span *ngFor="let email of branch.email_contacts">
        <br/>{{email}}
      </span>

      <p><span>FACEBOOK</span><br/><a href="http://facebook.com/balikbayadph"
                                      target="_blank">facebook.com/balikbayadph</a>
      </p>
    </div>

  </div>
</section>
